import React, { useMemo } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { MODE_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import JudgementForNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementForNonCompensation';
import { getNewCivj } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import JudgementNonCompensationRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementNonCompensationRecap';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';

export interface InjuredVictimsRecapProps {
  intl: IntlShape;
  listings: Listings;
  isManager?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  expertises?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  judgementOnMeritsRequest?: any;
  civjvms?: any;
  civj?: any;
  civjWithNonCompensation?: any;
  isContested?: boolean;
  handleOpenContestation?: Function;
  handleExpertiseChange?: Function;
  civilJudgementType?: any;
  handleCivJvmChange: Function;
  judgementOnMerits: any;
  sagisVictimInfo: any;
  mode?: string;
  modeType?: string;
  judgement: any;
  setJudgement: Function;
  setCivilJudgementUpdateExpertise?: Function;
  setJudgementOnMeritsRequest?: Function;
  expertiseType?: any;
  civilJudgementUpdateExpertise?: any;
  judgementForNonCompensation?: any;
  expertiseJudgementAddDocumentId?: any;
  victim?: any;
  civjvmRequest: any;
  setCivjvmRequest: Function;
  setCivilJudgements?: Function;
  civilJudgements: any;
  withAccountingExpertise?: any;
  setCivilJudgementUpdateAccountingExpertise?: Function;
  civilJudgementUpdateAccountingExpertise?: any;
  judgementAddDocExpertises?: any;
  isDisabled: boolean;
}
const InjuredVictimsRecap: React.FC<InjuredVictimsRecapProps> = ({
  ...props
}): JSX.Element => {
  const currentCivj = useMemo(
    () =>
      get(props.civjWithNonCompensation, 'isDeleted', false)
        ? getNewCivj(
            props.expertises,
            props.civjWithNonCompensation,
            INCIDENT_TYPE.VICTIM,
          )
        : props.civj,
    [props.civj],
  );
  return (
    <>
      {!isEmpty(props.civjWithNonCompensation) && (
        <div key={props.civjWithNonCompensation?.id} className="victims">
          <Grid container item spacing={2}>
            <Grid item xs={3} className="victim-item">
              {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
                ? `${get(
                    getVictimFromSagisInfo(
                      get(props.civjWithNonCompensation, 'victim.victimKey'),
                      props.sagisVictimInfo,
                    ),
                    'victimFirstName',
                    '',
                  )} ${get(
                    getVictimFromSagisInfo(
                      get(props.civjWithNonCompensation, 'victim.victimKey'),
                      props.sagisVictimInfo,
                    ),
                    'victimLastName',
                    '',
                  )}`
                : `${get(
                    props.civjWithNonCompensation,
                    'victim.firstName',
                    '',
                  )} ${get(
                    props.civjWithNonCompensation,
                    'victim.lastName',
                    '',
                  )}`}
            </Grid>
            {featureService.hasFeature(
              FEATURES.REASONS_FOR_NON_COMPENSATION,
            ) ? (
              <JudgementForNonCompensation
                listings={props.listings}
                judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                isManager={props.isManager}
                modeType={MODE_TYPES.RECAP}
                judgement={props.judgement}
                setJudgement={props.setJudgement}
                judgementForNonCompensation={props.judgementForNonCompensation}
                civjWithNonCompensation={props.civjWithNonCompensation}
                handleCivJvmChange={props.handleCivJvmChange}
                judgementOnMerits={props.judgementOnMerits}
                dahirAmount={props.dahirAmount}
                civjvm={props.civjvms}
                sagisVictimInfo={props.sagisVictimInfo}
                victim={props.victim}
                expertiseJudgementAddDocumentId={get(
                  props.civjWithNonCompensation,
                  'expertiseJudgementAddDocumentId',
                )}
                expertiseType={props.expertiseType}
                civj={currentCivj}
                setCivilJudgementUpdateExpertise={
                  props.setCivilJudgementUpdateExpertise
                }
                civilJudgementUpdateExpertise={
                  props.civilJudgementUpdateExpertise
                }
                setJudgementOnMeritsRequest={props.setJudgementOnMeritsRequest}
                civilJudgementType={props.civilJudgementType}
                civjvmRequest={props.civjvmRequest}
                setCivjvmRequest={props.setCivjvmRequest}
                expertises={props.expertises}
                handleExpertiseChange={props.handleExpertiseChange}
                setCivilJudgements={props.setCivilJudgements}
                civilJudgements={props.civilJudgements}
                isAppeal={props.isAppeal}
                withAccountingExpertise={props.withAccountingExpertise}
                setCivilJudgementUpdateAccountingExpertise={
                  props.setCivilJudgementUpdateAccountingExpertise
                }
                civilJudgementUpdateAccountingExpertise={
                  props.civilJudgementUpdateAccountingExpertise
                }
                judgementAddDocExpertises={props.judgementAddDocExpertises}
                isDisabled={props.isDisabled}
                isRejected={props.isRejected}
              />
            ) : (
              <JudgementNonCompensationRecap
                civjWithNonCompensation={props.civjWithNonCompensation}
                isManager={props.isManager}
                handleCivJvmChange={props.handleCivJvmChange}
                mode={undefined}
                listings={props.listings}
                judgementOnMerits={props.judgementOnMerits}
                judgement={props.judgement}
                setJudgement={props.setJudgement}
                victim={props.victim}
                isAppeal={props.isAppeal}
                isRejected={props.isRejected}
              />
            )}
          </Grid>
        </div>
      )}
    </>
  );
};

export default injectIntl(InjuredVictimsRecap);
